function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBreakDone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "126px",
    height: "75px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "none"
    },
    d: "M0 0L0 75L76 75L76 0L0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      stroke: "none"
    },
    d: "M31 5L31 21L33 21L33 5L31 5M39 9L39 21L41 21L41 9L39 9M23 13L23 21L25 21L25 13L23 13M47 13L47 21L49 21L49 13L47 13M14 23L14 55C14.0003 59.355 13.2676 64.962 16.6528 68.3472C20.4104 72.1049 27.1862 71 32 71C44.059 71 57.8579 73.898 58 58C73.367 56.2884 73.367 33.7116 58 32L58 23L14 23z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bade94",
      stroke: "none"
    },
    d: "M18 25L18 26L54 26C44.4404 21.9886 28.3869 25 18 25z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a8d578",
      stroke: "none"
    },
    d: "M17 26L17 54C17 57.3893 16.0464 62.7129 18.0278 65.6821C21.5512 70.9622 40.2121 68.0391 46 67.9992C48.7252 67.9805 52.2447 68.2709 53.9722 65.6821C55.9536 62.7129 55 57.3894 55 54L55 26L17 26z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bade94",
      stroke: "none"
    },
    d: "M16 27L16 65L17 65C17 54.0894 20.2113 37.0359 16 27M55 27L55 65L56 65C56 54.0894 59.2113 37.0359 55 27z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#757575",
      stroke: "none"
    },
    d: "M58.6667 31.3333L59.3333 31.6667L58.6667 31.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a8d578",
      stroke: "none"
    },
    d: "M58 33L58 57C70.7483 52.6633 70.7483 37.3367 58 33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      stroke: "none"
    },
    d: "M23 36L23 40L25 40L25 36L23 36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#818181",
      stroke: "none"
    },
    d: "M69 41L70 42L69 41z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      stroke: "none"
    },
    d: "M23 42L23 63L25 63L25 42L23 42z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#818181",
      stroke: "none"
    },
    d: "M69 48L70 49L69 48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#757575",
      stroke: "none"
    },
    d: "M58.6667 58.3333L59.3333 58.6667L58.6667 58.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#939393",
      stroke: "none"
    },
    d: "M14 65L15 66L14 65M57 65L58 66L57 65z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a8a8a8",
      stroke: "none"
    },
    d: "M15 67L16 68L15 67M56 67L57 68L56 67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bade94",
      stroke: "none"
    },
    d: "M20 68L20 69L52 69L20 68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a8a8a8",
      stroke: "none"
    },
    d: "M17 69L18 70L17 69M54 69L55 70L54 69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#939393",
      stroke: "none"
    },
    d: "M19 70L20 71L19 70M52 70L53 71L52 70z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreakDone);
export default __webpack_public_path__ + "static/media/break_done.0f841fa0ec636cfa7a9534b5de4576a1.svg";
export { ForwardRef as ReactComponent };